export const customListOrdersById = /* GraphQL */ `
  query ListOrderItemById(
    $typename: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemById(
      typename: $typename
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;

export const customListOrdersByStatus = /* GraphQL */ `
  query ListOrderItemByStatus(
    $typename: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByStatus(
      typename: $typename
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;

export const customListOrdersByPrintManufacturer = /* GraphQL */ `
  query ListOrderItemByPrintManufacturer(
    $typename: String!
    $printManufacturer: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByPrintManufacturer(
      typename: $typename
      printManufacturer: $printManufacturer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;

export const customListOrdersByDeliveryDate = /* GraphQL */ `
  query ListOrderItemByDeliveryDate(
    $typename: String!
    $deliveryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByDeliveryDate(
      typename: $typename
      deliveryDate: $deliveryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;
export const customListOrdersByUploadedAndReUploaded = /* GraphQL */ `
  query ListOrderItemByStatus(
    $typename: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByStatus(
      typename: $typename
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;
export const customListOrdersByUploadedDate = /* GraphQL */ `
  query ListOrderItemByUploadedDate(
    $typename: String!
    $uploadedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByUploadedDate(
      typename: $typename
      uploadedDate: $uploadedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;

export const customListOrdersByCreatedAt = /* GraphQL */ `
  query ListOrderItemByCreatedAt(
    $typename: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByCreatedAt(
      typename: $typename
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chooseUpload
        customerNumber
        printManufacturer
        status
        deliveryDate
        uploadedDate
        createdAt
        typename
        updatedAt
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        positions {
          productGroup
        }
      }
      nextToken
    }
  }
`;
